module.exports = __webpack_public_path__ + "img/menu_mens_placenta.a6856e5a.png";